import ChartOptions from "../config/ChartOptions";
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from './../../../tailwind.config'
import ListingData from "./ListingData";
import {sortBy, isEqual, isEmpty} from "lodash";
import Calculator from "../calculator";
import DatasetModel from "./DatasetModel";

const config = resolveConfig(tailwindConfig)

const ChartInteractions = {
  get store() {
    return Spruce.store('configurator')
  },

  resolveOptions(datasets) {
    return ChartOptions(datasets, this.calculationStyle, this.collectionName)
  },

  updateChartData(withOptions = true) {

    LineChart.data.datasets = this.resolveDatasets()

    if (withOptions)
      LineChart.options = this.resolveOptions(this.resolveDatasets()).options

    this.setChartActiveItem()

    return LineChart.update()
  },

  updateChartActiveItem() {
    this.setChartActiveItem()
    LineChart.update()
  },

  setChartActiveItem() {
    LineChart.data.datasets.forEach((set) => {
      if (this.isLineActive(set)) {
        set.backgroundColor = config.theme.colors.accent.default
        set.borderColor = config.theme.colors.accent.default
        set.borderWidth = 4
      } else {
        set.backgroundColor = config.theme.colors.accent.light
        set.borderColor = config.theme.colors.accent.light
        set.borderWidth = 3
      }
    })
  },

  isLineActive(item) {

    const activeItem = ListingData.getItemById(this.store.listActiveItem)
    const currentItem = ListingData.getItemById(item.nid)

    const activeCollection = activeItem ? sortBy(activeItem[this.collectionName], [parseFloat(this.oilFlowLabel)]) : null
    const collection = currentItem ? sortBy(currentItem[this.collectionName], [parseFloat(this.oilFlowLabel)]) : null

    return item.nid === this.store.listActiveItem || this.compareCollectionWith(collection, activeCollection)
  },

  compareCollectionWith(collection1, collection2) {
    return isEqual(collection1, collection2)
  },

  get collectionName() {
    return this.display === 'cooling_power' ? 'cooling_performances' : 'pressure_losses'
  },

  get oilFlowLabel() {
    return `${this.calculationStyle}_oil_flow`
  },

  getDataLabel(display) {
    return display === 'cooling_performances'
      ? `${this.calculationStyle}_cooling_performance`
      : `${this.calculationStyle}_pressure_loss`
  },

  get calculationStyle() {
    return this.store.getDisplayStyle()
  },

  get display() {
    return this.store.chartDisplay
  },

  getGraphDataForProduct(nid, collectionName) {

    const data = []
    const item = ListingData.getItemById(nid)
    const collection = sortBy(item[collectionName], [parseFloat(this.oilFlowLabel)]).reverse()

    collection.forEach(product => {
      data.push({x: parseFloat(product[this.oilFlowLabel]), y: parseFloat(product[this.getDataLabel(collectionName)])})
    })

    return data;
  },

  resolveDatasets() {
    const datasets = []

    this.store.listingDataChecked.forEach(nid => this.pushDataset(nid, datasets), this)
    this.pushPSPPoint(datasets)

    return datasets
  },

  pushDataset(nid, datasets, collectionName) {
    datasets.push(DatasetModel(nid,
      this.getGraphDataForProduct(nid, collectionName ?? this.collectionName)
    ))
  },

  resolveDatasetForOneProduct(nid, collectionName) {
    const datasets = []

    this.pushDataset(nid, datasets, collectionName ?? 'cooling_performances');

    if (collectionName === 'cooling_performances')
      this.pushPSPPoint(datasets)

    return datasets
  },

  pushPSPPoint(datasets) {

    if (isEmpty(datasets))
      return

    if (this.showPSPPoint) {
      datasets.push(this.PSPPoint)
    }
  },

  get PSPPoint() {
    return {
      label: false,
      pointBackgroundColor: config.theme.colors.vivid.default,
      pointBorderColor: config.theme.colors.vivid.default,
      pointRadius: 5,
      data: [{x: parseInt(Calculator.options.oilFlowRate), y: Calculator.options.specificCoolingCapacity}],
      fill: false,
    }
  },

  get showPSPPoint() {
    return Calculator.options.oilFlowRate && Calculator.options.specificCoolingCapacity && this.isDisplayCoolingPower
  },

  get isDisplayCoolingPower() {
    return this.display === 'cooling_power'
  },

  createImage(chart) {
    const element = document.createElement('img')
    element.src = chart.toBase64Image()
    return element
  },

  async printImages() {
    const nodes = document.querySelectorAll('[x-data].print_image')

    await Promise.all([...nodes].map(async el => {
      const component = el.__x
      const wrapper = component.getRefsProxy().wrapper
      const chart = component.getUnobservedData().chart
      wrapper.append(ChartInteractions.createImage(chart))
      component.getRefsProxy().chart.remove()
    }))
  }

}

export default ChartInteractions
